// extracted by mini-css-extract-plugin
export var infoItem = "_m8-1";
export var title = "_m8-0";